import React from "react";
import { Dropdown } from 'react-bootstrap';
import style from './style.module.scss';

export default function Dropdown2(props) {

  const { toggle, menu } = props;

  return (
    <Dropdown>
      <Dropdown.Toggle className={style.toggle}>
        {toggle}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {menu.map(__menu_item => (
          <Dropdown.Item onClick={__menu_item.action}>
            {__menu_item.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}